<div class="next-repeat">{{ 'campaigns.scheduler.nextRepeat' | translate }}:</div>
<br />
@let scheduledDate =
	data.info.status === CampaignStatus.SCHEDULED || data.info.status === CampaignStatus.WAITING_FOR_APPROVAL
		? data.info.scheduled
		: data.nextRunAt;
@switch (utils.getNextRunDay(scheduledDate)) {
	@case (CampaignNextRunDay.EMPTY) {
		—
	}
	@case (CampaignNextRunDay.TODAY) {
		{{ 'campaigns.scheduler.today' | translate }},
		{{ scheduledDate | date: dateFormat.timeFormat }}
	}
	@case (CampaignNextRunDay.TOMORROW) {
		{{ 'campaigns.scheduler.tomorrow' | translate }},
		{{ scheduledDate | date: dateFormat.timeFormat }}
	}
	@case (CampaignNextRunDay.OTHER) {
		{{ scheduledDate | dateFormat }}
	}
}
